import { ITransaction } from './transaction'

// OPEN — заявка идущего расчётного периода, принимает подачи. С закрытием периода она
// переходит в PENDING и ждёт выплаты. Как подана каждая сумма — в submissions[].source
export enum EWithdrawalRequestStatus {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED'
}

export interface ICreateWithdrawalRequest {
  seller_id?: string
  sum: number
  transaction_ids: string[]
}

export interface IWithdrawalRequestListRequest {
  skip: string
  limit: string
  status?: EWithdrawalRequestStatus | string
  seller_id?: string
}

export interface IWithdrawalRequestSeller {
  _id?: string
  shop_name?: string
  full_name?: string
  first_name?: string
  last_name?: string
  name?: string
}

export enum EWithdrawalSubmissionSource {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO'
}

export interface IWithdrawalSubmission {
  source: EWithdrawalSubmissionSource
  sum: number
  transaction_ids?: string[]
  submitted_at: string
  // номер заявки, слитой в эту при переходе на расчётные периоды
  merged_request_number?: number
}

export interface IWithdrawalRequest {
  _id: string
  number?: number | string
  seller_id?: string | IWithdrawalRequestSeller
  seller?: IWithdrawalRequestSeller
  shop_name?: string
  sum: number
  status: EWithdrawalRequestStatus | string
  transaction_ids?: string[] | ITransaction[]
  transactions?: ITransaction[]
  // расчётный период, дни YYYY-MM-DD включительно
  period_start?: string
  period_end?: string
  submissions?: IWithdrawalSubmission[]
  last_submission_at?: string
  createdAt: string
  updatedAt?: string
}

export interface ICreateWithdrawalRequestResponse extends IWithdrawalRequest {
  // сколько продавец переплатил комиссии за отмены по заказам заявки
  penalty_commission_sum?: number
}

export interface IWithdrawalRequestListResponse {
  requests: IWithdrawalRequest[]
  count: number
}

export interface ISetAutoWithdrawal {
  seller_id?: string
  enabled: boolean
}

export interface ISetAutoWithdrawalResponse {
  auto_withdrawal: boolean
  // сколько продаж ушло в заявку сразу при включении
  submitted_count: number
}

export interface IUpdateWithdrawalRequestStatus {
  status: EWithdrawalRequestStatus
}
